import React, { useEffect, useRef } from 'react';
import katex from 'katex';
import renderMathInElement from 'katex/dist/contrib/auto-render';
import 'katex/dist/katex.min.css';

const MathRenderer = ({ htmlContent }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      let cleanHtml = htmlContent || '';

      // Clean trailing space slash bugs
      cleanHtml = cleanHtml.replace(/\\([ \t])/g, ' ');

      // Set raw HTML first
      containerRef.current.innerHTML = cleanHtml;

      // 1. HARD FORCED DOM STYLING FOR IMAGES
      const images = containerRef.current.querySelectorAll('img');
      images.forEach((img) => {
        img.style.setProperty('display', 'block', 'important');
        img.style.setProperty('max-width', '100%', 'important');
        img.style.setProperty('width', 'auto', 'important');
        img.style.setProperty('height', 'auto', 'important');
        img.style.setProperty('margin', '12px auto', 'important');

        if (img.parentElement) {
          img.parentElement.style.setProperty('display', 'block', 'important');
          img.parentElement.style.setProperty('width', '100%', 'important');
        }
      });

      // 2. KATEX AUTO-RENDER (DOM Static & Print Engine Compatible)
      try {
        renderMathInElement(containerRef.current, {
          delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '$', right: '$', display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true }
          ],
          throwOnError: false,
        });
      } catch (e) {
        console.error('KaTeX rendering error:', e);
      }

      // 3. FORCE STRICT LEFT-ALIGNMENT ON RENDERED ELEMENTS
      const katexDisplays = containerRef.current.querySelectorAll('.katex-display');
      katexDisplays.forEach((el) => {
        el.style.setProperty('text-align', 'left', 'important');
        el.style.setProperty('margin', '8px 0', 'important');
        el.style.setProperty('width', '100%', 'important');

        const childKatex = el.querySelector('.katex');
        if (childKatex) {
          childKatex.style.setProperty('text-align', 'left', 'important');
          childKatex.style.setProperty('display', 'inline-block', 'important');
        }

        const katexHtml = el.querySelector('.katex-html');
        if (katexHtml) {
          katexHtml.style.setProperty('text-align', 'left', 'important');
        }
      });
    }
  }, [htmlContent]);

  return (
    <>
      {/* Printable styles override */}
      <style>{`
        .katex-display {
          text-align: left !important;
          margin: 8px 0 !important;
        }
        .katex-display > .katex {
          text-align: left !important;
          display: inline-block !important;
        }
        @media print {
          .katex-display {
            text-align: left !important;
            margin: 8px 0 !important;
            display: block !important;
          }
          .katex {
            font-size: 1em !important;
            text-align: left !important;
          }
        }
      `}</style>
      <div
        ref={containerRef}
        className="math-content"
        style={{
          lineHeight: '1.9',
          fontSize: '1.1rem',
          color: '#212529',
          textAlign: 'left',
          width: '100%',
          wordBreak: 'break-word',
          overflowWrap: 'break-word'
        }}
      />
    </>
  );
};

export default MathRenderer;